import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const guestHouseSections = [
    { id: "about", name: "अतिथिगृह के बारे में" },
    { id: "rules", name: "नियम एवं दिशा निर्देश" },
    { id: "committee", name: "समिति सदस्य" },
    { id: "facilities", name: "कमरे एवं अन्य सुविधाएं" },
    { id: "forms", name: "प्रपत्र (फार्म)" },
    { id: "contact", name: "सम्पर्क" },
];

const guestHouseContent = {
    about: (
        <p>
            मकान नं. 942, उपायुक्त निवास के सामने, सैक्टर-19, कैथल। यह भवन किरायानामा के आधार पर दिनांक <strong>01/02/2025</strong> से <strong>31/12/2025</strong> तक किराये पर लिया गया है।
        </p>
    ),
    rules: (
        <p>
            पत्र संलग्न (पताका ‘क’)
        </p>
    ),
    committee: (
        <p>
            कोई नहीं है।
        </p>
    ),
    facilities: (
        <p>
            03 कमरें (01 ए.सी. कमरा व 02 साधारण कमरें)
        </p>
    ),
    forms: (
        <p>
            रसीद आधार पर
        </p>
    ),
    contact: (
        <div className="table-responsive">
            <table className="table table-bordered w-100" style={{ fontSize: "18px" }}>
                <thead className="table-dark">
                    <tr>
                        <th style={{ width: "25%" }}>शीर्षक</th>
                        <th>विवरण</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>नाम</td>
                        <td><strong>श्री सुभाष चन्द</strong></td>
                    </tr>
                    <tr>
                        <td>पद</td>
                        <td>सम्पदा अधिकारी, महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल</td>
                    </tr>
                    <tr>
                        <td>फोन नं.</td>
                        <td><a href="tel:9416586115">9416586115</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    ),
};

export default function GuestHouse() {
    const [activeTab, setActiveTab] = useState("about");
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for small screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">अतिथिगृह</h5>
                <div className="flex-grow-1 overflow-auto">
                    {guestHouseSections.map((section) => (
                        <p
                            key={section.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeTab === section.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"}`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeTab === section.id ? "#77236b" : "",
                            }}
                            onClick={() => {
                                setActiveTab(section.id);
                                setShowSidebar(false);
                            }}
                        >
                            {section.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => setShowSidebar(false)}
            >
                <h4 className="text-center mb-4 fw-bold" style={{ color: '#77236b' }}>
                    {guestHouseSections.find(s => s.id === activeTab)?.name}
                </h4>
                {guestHouseContent[activeTab] || <p className="text-muted">कृपया एक अनुभाग चुनें।</p>}
            </main>
        </div>
    );
}
